<template>
    <div class="boot-load-error">
        <EmptyState
            :title="$t('errors.general')"
            image="oops"
        >
            <i18n-t tag="p" keypath="bootLoadError.logInQuestion">
                <a
                    href="#"
                    @click.prevent="handleLogout"
                >{{ $t('bootLoadError.loggingIn') }}
                </a>
            </i18n-t>
        </EmptyState>
    </div>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue';
import { auth } from '@/plugins/auth';

export default {
    components: {
        EmptyState,
    },
    methods: {
        handleLogout() {
            auth.logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    .boot-load-error {
        padding: $spacing-400;
        text-align: center;
    }

    h2 {
        margin: $spacing-300 0 $spacing-300;
    }

    h4 {
        margin-bottom: $spacing-400;
    }
</style>
